import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface SafetyModulesGuardProps {
  children: React.ReactElement;
}

// P4-04: gate on the effective org's hasSafetyModules only. Deliberately no
// isSuperAdmin bypass: hasSafetyModules already reflects the impersonated org,
// and QR provisioning must never run for an org without safety modules.
const SafetyModulesGuard: React.FC<SafetyModulesGuardProps> = ({ children }) => {
  const { hasSafetyModules, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a spinner
  }

  if (!hasSafetyModules) {
    return <Navigate to="/settings" replace />;
  }

  return children;
};

export default SafetyModulesGuard;
